import type { PricingTableSummaryValues } from '../types/pricing-table';

export const defaultSummaryValues: PricingTableSummaryValues = {
  displayName: '',
  price: {
    displayName: '',
    value: '',
    enabled: false,
    flatFee: false,
  },
  discount: {
    displayName: '',
    value: '',
    enabled: false,
    flatFee: false,
  },
  tax: {
    displayName: '',
    value: '',
    enabled: false,
    flatFee: false,
  },
};
